export default __webpack_public_path__ + "static/media/rightPagination.67a53220.svg";